<template>
  <div class="indexBg">
   
  </div>
</template>
<script>
import { Notify } from 'vant' // 添加这行导入
import { getPublic } from '@/api/index'
export default {
  name: 'indexPage',
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {},

  methods: {
  
  }
}
</script>

<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100vh;
  background: url("@/assets/abc.jpg") no-repeat center / 100% 100%;
}

</style>
